export default {
  path: '/',
  name: 'Home',
  component: () => import(/* webpackChunkName: "base/home" */ '../views/HomeView.vue'),
  meta: {
    exclude: false,
    requiresAuth: true
  }
}
